import { Title, ListDescription, Section } from "@vshp/ui-components";

function ProgramInfo({ cost, degree, form, organization, term }) {
  return (
    <Section border={true}>
      <Title type="h2">ОСНОВНАЯ ИНФОРМАЦИЯ</Title>
      <ListDescription>
        <ListDescription.Item title="ОБРАЗОВАТЕЛЬНАЯ ОРГАНИЗАЦИЯ" description={organization.length ? organization : "—"} />
        <ListDescription.Item title="ФОРМА ОБУЧЕНИЯ" description={form.length ? form : "—"} />
        <ListDescription.Item title="НАПРАВЛЕНИЕ ОБУЧЕНИЯ" description={degree.length ? degree : "—"} />
        <ListDescription.Item title="СРОК ОБУЧЕНИЯ" description={term.length ? term : "—"} />
        <ListDescription.Item title="СТОИМОСТЬ ОБУЧЕНИЯ" description={cost.length ? cost : "—"} />
      </ListDescription>
    </Section>
  );
}

export default ProgramInfo;
